/** Канон бэкенда: `backend/core/access/permissions.go` */
export const PERM_ORGANIZATION_SETTINGS_VIEW = 'organization:settings:view' as const;
export const PERM_ORGANIZATION_SETTINGS_UPDATE = 'organization:settings:update' as const;
